import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { aceGray, error, prestoPurple, shuffleGray, urgentDate } from '../../../../../styles/colors';
import { Layouts } from '../../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	blogPickerRoot: {
		paddingTop: 8,
		paddingBottom: 16,
		boxSizing: 'border-box',
	},
	blogPickerTime: {
		marginTop: 16,
		width: 120,
		':has(*) > input': {
			appearance: 'none',
		},
		':has(*) > input::-webkit-calendar-picker-indicator': {
			display: 'none',
			appearance: 'none',
		},
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: 24,
	},
	timeAndFooter: {
		paddingLeft: 16,
		paddingRight: 16,
		boxSizing: 'border-box',
	},
	editor: {
		height: '100%',
		overflow: 'auto',
		width: '100%',
	},
	editorContainer: {
		border: `1px solid ${aceGray}`,
		borderLeft: 'none',
		borderRadius: '0 8px 8px 0',
		backgroundColor: `${shuffleGray}80`,
		flexGrow: 1,
		height: '100%',
		overflow: 'hidden',
		paddingLeft: 10,
		position: 'relative',
	},
	generatingContentLoader: {
		borderTopLeftRadius: 0,
		borderBottomLeftRadius: 0,
	},
	editorContainerError: {
		border: `1px solid ${error}`,
	},
	editorContainerSuccess: {
		border: `1px solid ${prestoPurple}`,
		opacity: 0.5,
	},
	image: {
		aspectRatio: '1 / 1',
		objectFit: 'cover',
		height: '100%',
	},
	imageContainer: {
		aspectRatio: '1 / 1',
		borderRadius: '8px 0 0 8px',
		flexShrink: 0,
		height: 'calc(100% + 2px)',
		overflow: 'hidden',
	},
	largeImage: {
		maxHeight: 200,
		width: 'auto',
	},
	stack: {
		...Layouts.horizontalStack(0),
		height: 160,
	},
	MultiCampaignTemplateItem: {
		display: 'flex',
		alignItems: 'center',
		gap: 20,
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		flex: '1 1 0%',
	},
	headerRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-end',
		gap: THEME.spacing.md,
	},
	templateTitle: {
		fontWeight: 600,
		fontSize: 18,
		overflow: 'hidden',
		'-webkit-box-orient': 'vertical',
		'-webkit-line-clamp': '2',
		// @ts-ignore
		display: '-webkit-box',
	},
	errorMessage: {
		color: urgentDate,
		fontSize: 12,
		margin: 0,
	},
	recommendedDateContainer: {
		display: 'flex',
		alignItems: 'center',
		fontSize: 12,
		gap: 8,
		flexShrink: 0,
	},
	generateContentInfoContainer: {
		display: 'flex',
		width: '100%',
	},
	showOriginalContentToggle: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		flexGrow: 1,
		gap: 8,
	},
	showOriginalContentLabel: {
		fontSize: 12,
	},
});
